import * as angular from "angular";
import {IController} from "angular";

export class SaveFooterComponent implements IController {
  onSave: Function;
  onCancel: Function;
}

angular
  .module('bringoz.admin.commons')
  .component('saveFooter', {
    bindings: {
      onSave: '&',
      onCancel: '&'
    },
    template: require('./save-footer.html').default,
    controller: SaveFooterComponent
  });
